import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import RefundCalculatorItem from "./refundCalculatorItem";
import utils from "../../utils/utils";

const RefundCalculator = ({order}) => {
  const [result, setResult] = useState(order.items.map(oi => {
    // need to prefill child array with 0s, otherwise setting newResult[index][oiIndex] = newRefundAmount causes errors
    return [...Array(oi.quantity).fill(0)];
  }));

  const times = x => f => {
    if (x > 0) {
      f()
      times(x - 1)(f)
    }
  }

  const refundSum = utils
    .getRoundedPrice(result.reduce((sum, value) => sum + value.reduce((sum2, value2) => sum2 + value2, 0), 0));

  return (
    <div>
      <h2>
        <FormattedMessage id={'refund.create.order.item.calculation.header'}/>
      </h2>
      <table className="table table-striped">
        <thead>
        <tr>
          <th scope="col"><FormattedMessage id={'refund.create.order.item.calculation.table.name'}/></th>
          <th scope="col"><FormattedMessage id={'refund.create.order.item.calculation.table.price'}/></th>
          <th scope="col"><FormattedMessage id={'refund.create.order.item.calculation.table.unit.price'}/></th>
          <th scope="col"><FormattedMessage id={'refund.create.order.item.calculation.table.enter.weight'}/></th>
          <th scope="col"><FormattedMessage id={'refund.create.order.item.calculation.table.result'}/></th>
        </tr>
        </thead>

        <tbody>
        {
          order.items.map((orderItem, index) => {
            const items = Array(orderItem.quantity).fill(orderItem);

            return items.map((oi, oiIndex) => {
              return (
                <RefundCalculatorItem key={oiIndex} orderItem={oi} onRefundAmountChange={(newRefundAmount) => {
                  const newResult = [...result];
                  if (!newResult[index]) {
                    newResult[index] = [];
                  }
                  newResult[index][oiIndex] = newRefundAmount;
                  setResult(newResult);
                }}/>
              );
            });
          })
        }
        </tbody>
      </table>

      <h4 className="m-b-6 text-right">
        <FormattedMessage id={'refund.create.order.item.calculation.total.refund'}/>: {refundSum}€
      </h4>
    </div>
  );
}

RefundCalculator.propTypes = {
  order: PropTypes.object.isRequired,
};

RefundCalculator.defaultProps = {
  action: 'create',
};

export default injectIntl(RefundCalculator);